import React, {useState} from "react";
import { InputContainer, ReactCalendar } from "./styled";
import { addDays, format, isValid, parse } from "date-fns";
import { DateCalendarType } from "./DateCalendarType";
import MaskedInput from "react-text-mask";

interface RangeDatePickerProps {
   date: DateCalendarType;
   handleChange: (arg: DateCalendarType | Date) => void;
   isCustomDateSelected: boolean;
}

const RangeDatePicker: React.FC<RangeDatePickerProps> = ({
   date,
   handleChange,
   isCustomDateSelected,
}) => {
   const formatDate = (value: number | Date): string | number => {
      if (!value) return value;
      return format(value, "MM/dd/yyyy");
   };

   const[startDate, setStartDate] = useState(date ? formatDate(date[0]) : "");
   const[endDate, setEndDate] = useState(date ? formatDate(date[1]) : "");

   const handleDayPickerSelect = (value: DateCalendarType | Date) => {
      handleChange(value);

      if (value) {
         setStartDate(formatDate(value[0]));
         setEndDate(formatDate(value[1]))
      }
   };

   const handleStartDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      setStartDate(e.target.value); // keep the input value in sync
      handleDateChange(e, 0);
   };

   const handleEndDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      setEndDate(e.target.value); // keep the input value in sync
      handleDateChange(e, 1);
   };

   const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>, place) => {
      const parsedDate = parse(e.target.value, "MM/dd/yyyy", new Date());

      if (isValid(parsedDate) && date) {
         const current = new Date();
         current.setMonth(current.getMonth() + 12);
         const firstDateOfMonth = new Date(format(current, "MM/01/yyyy"));

         if (!(parsedDate < addDays(new Date(), -1) || parsedDate > firstDateOfMonth)) {
            date[place] = parsedDate;
            handleChange(date);
         }
      }
   }

   const tileDisabled = ({ date }) => {
      const current = new Date();
      current.setMonth(current.getMonth() + 12);
      const firstDateOfMonth = new Date(format(current, "yyyy-MM-01"));
      return date < addDays(new Date(), -1) || date > firstDateOfMonth;
   };

   const maskingFormatForDate: (string | RegExp)[] = [
      /\d/,
      /\d/,
      "/",
      /\d/,
      /\d/,
      "/",
      /\d/,
      /\d/,
      /\d/,
      /\d/,
   ];

   return (
      <>
         <InputContainer>
            <label htmlFor="from">From</label>
            <MaskedInput
                mask={maskingFormatForDate}
                id="from"
                placeholder="From"
                value={startDate}
                title="Date should be MM/DD/YYYY."
                pattern="[0-9]{2}\/[0-9]{2}\/[0-9]{4}"
                onChange={handleStartDateChange}
            />

            <label htmlFor="to">To</label>
            <MaskedInput
                mask={maskingFormatForDate}
                id="to"
                placeholder="To"
                value={endDate}
                title="Date should be MM/DD/YYYY."
                pattern="[0-9]{2}\/[0-9]{2}\/[0-9]{4}"
                onChange={handleEndDateChange}
            />
         </InputContainer>
         <ReactCalendar
            formatShortWeekday={(locale, date) =>
               format(new Date(date), "EEEEE")
            }
            tileDisabled={tileDisabled}
            view="month"
            calendarType="US"
            value={date}
            onChange={handleDayPickerSelect}
            selectRange={isCustomDateSelected}
         />
      </>
   );
};

export default RangeDatePicker;
